<template>
  <Loader v-if="isLoading"></Loader>
  <b-card v-else>
    <table class="table table-sm table-striped table-hover">
      <tbody>
      <tr
              v-for="item in items"
              :key="item['@id']">
        <td>
          {{ item['description'] }}
        </td>
        <td>
          <router-link :to="{name: 'ConfTypeShow', params: { id: item['@id'] }}">
            <button class="float-right btn btn-link fa fa-search" v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true" />
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  components: {
    Loader
  },
  computed: mapGetters({
    deletedItem: 'conftype/del/deleted',
    error: 'conftype/list/error',
    items: 'conftype/list/items',
    isLoading: 'conftype/list/isLoading',
    view: 'conftype/list/view'
  }),

  created () {
    this.getPage()
    this.getClientTypes()
  },

  methods: mapActions({
    getPage: 'conftype/list/default',
    getClientTypes: 'clienttype/list/default'
  })
}
</script>
